const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const curry = require('lodash/fp/curry');
const fill = require('lodash/fill');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;

const padArray = curry((length, padWith, arr) => {
  if (arr.length >= length) {
    return arr;
  }

  return arr.concat(fill(new Array(length - arr.length), padWith));
});

function getQS(parsedMetaData) {
  return {
    pfId: parsedMetaData.portfolio.pfRelId,
    branchCode: parsedMetaData.portfolio.branchCode,
  };
}

/**
 * Assets API Service
 * @param {Object} config - config
 * @param {string} config.baseUrl - Base url with trailing slash e.g. 'https://1.2.3.4:5678/api/equities/'
 * @param {string} config.authToken - Authorization header bearer token
 * @param {string} config.positionsUrl - Url for positions, e.g. 'equities-positions'
 * @param {string} config.transactionsUrl - Url for transactions, e.g. 'equities-transactions'
 * @param {string} config.valueMovementUrl - Url for value movement, e.g. 'equities-value-movement'
 * @param {string} config.requestHandler - Request handler, returning a Promise
 * @returns {Object} - The service object
 */
function apiFactory({
  baseUrl,
  transBaseUrl,
  positionsUrl,
  transactionsUrl,
  valueMovementUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };
  const reqOpts = { headers, method: 'POST', json: true };
  // const reqOpts = {
  //   headers: headers,
  //   method: 'POST',
  //   timeout: 120000
  // };
  // const reqOpts = {
  //   headers: merge(headers, {
  //     Authorization: getWs02Token(),
  //     'X-CLIENT-IP': getIPaddress(),
  //   }),
  //   method: 'POST'
  // };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  return {

    //
    // getCurrencyExposure(portfolioId, metaData) {
    //   const url = getUrl('portfolio-currency-exposure');
    //   const reqOpts = {headers, method: 'POST', json: true }
    //   const parsedMetaData = parseRequestMetaData(metaData);
    //   const body = {
    //     userId: parsedMetaData.qs.userId,
    //     pfRelId: parsedMetaData.portfolio.pfRelId,
    //     branchCode: parsedMetaData.portfolio.branchCode,
    //     destinationCurrency: parsedMetaData.qs.destinationCurrency
    //   };
    //
    //   return requestHandler(merge(
    //     {},
    //     reqOpts,
    //     { url, body },
    //     parsedMetaData
    //   ));
    // },

    /**
     * Positions
     * @param {Object} qs - Request query parameters
     * @param {string} qs.pfId - Portfolio Id
     * @param {string} qs.userId - User Id
     * @param {string} qs.branchCode - Branch Code
     * @param {string} [qs.destinationCurrency] - Requested Destination Currency
     * @param {Object} metaData - encoded jwt and JSESSION
     * @returns {Promise} - Resolves with JSON-decoded body
     */
    getPositions: (portfolioId, metaData, posId) => {
      const parsedMetaData = parseRequestMetaData(metaData);
      // const qs = getQS(parsedMetaData);
      const body= {
        branchCode: parsedMetaData.portfolio.branchCode,
        pfRelId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        assetShortDesc:parsedMetaData.assetName.assetClassName,
        numberOfRows:5,
        destinationCurrency: parsedMetaData.qs.destinationCurrency,
        posId
      };

      // return requestArray(merge(reqOpts, {
      //   url: `${baseUrl}${positionsUrl}`,
      //   body,
      //   json: true,
      // }));
      return requestHandler(merge(
        {},
        reqOpts,
        {url: `${baseUrl}${positionsUrl}`, body},
        parsedMetaData
      ));

    },

    /**
     * Transactions
     * @param {Object} qs - Request query parameters
     * @param {string} qs.posId - Position Id
     * @param {string} qs.branchCode - Branch Code
     * @param {string} qs.userId - User Id
     * @param {Object} metaData - encoded jwt and JSESSION
     * @returns {Promise} - Resolves with JSON-decoded body
     */
    getTransactions: (extraQS, metaData) => {
      const parsedMetaData = parseRequestMetaData(metaData);
      const { posId } = extraQS;
      // const qs = merge(extraQS, getQS(parsedMetaData));
      const body= {
        posId: posId,
        branchCode: parsedMetaData.portfolio.branchCode,
        pfId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        destinationCurrency: parsedMetaData.qs.destinationCurrency
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url: `${transBaseUrl}${transactionsUrl}`, body },
        parsedMetaData
      ));

    },

    /**
     * Transactions
     * @param {Object} qs - Request query parameters
     * @param {string} qs.psSecNmb - Position Security Number
     * @param {string} qs.userId - User Id
     * @param {string} qs.branchCode - Branch Code
     * @param {string} qs.fromDate - Requested from date ddmmmyyyy
     * @param {string} qs.toDate - Requested to date ddmmmyyyy
     * @param {Object} metaData - encoded jwt and JSESSION
     * @returns {Promise} - Resolves with JSON-decoded body
     */
    getValueMovement: (extraQS, metaData) => {
      const parsedMetaData = parseRequestMetaData(metaData);
      const qs = merge(extraQS, getQS(parsedMetaData));

      return requestArray(merge(
        {},
        reqOpts,
        { url: `${baseUrl}${valueMovementUrl}`, qs },
        parsedMetaData
      )).then(padArray(5, null));
    },
  };
}
module.exports = apiFactory;